import { ChartData } from '../../@types/data/types';

export type View =
  | 'capillary-pressure'
  | 'kr-analysis'
  | 'zones'
  | 'correlation'
  | 'kr-pc-model'
  | 'ghe-inputs'
  | 'ml-analogues'
  | 'analogue-tables'
  | 'krel-pc-selection'
  | 'ix-tables';

export const initChartData: ChartData = {
  receivedData: [],
  variables: { a: 0, b: 0, lambda: 0, PceD: 0 },
  line: [],
  pcxsw: [],
  correctedPcxsw: [],
  new_pcxsw: [],
  new_pcdxswd: [],
  pcdxswd: [],
};

export const emptyConfig: Record<View, { title: string; subtitle: string }> = {
  'capillary-pressure': {
    title: 'No samples loaded',
    subtitle: 'Select a project and well to load capillary pressure data.',
  },
  'kr-analysis': {
    title: 'No samples loaded',
    subtitle: 'Select a project and well to load Kr analysis data.',
  },
  zones: {
    title: 'No zones defined',
    subtitle: 'Load input data first, then define the reservoir zones.',
  },
  correlation: {
    title: 'No correlation data',
    subtitle: 'Run the analysis to see correlation results here.',
  },
  'kr-pc-model': {
    title: 'No model configured',
    subtitle: 'Configure the Kr × Pc model parameters to get started.',
  },
  'ghe-inputs': {
    title: 'No GHE inputs',
    subtitle: 'Provide the gas-hydrate equilibrium inputs to proceed.',
  },
  'ml-analogues': {
    title: 'No ML results',
    subtitle: 'Run the ML vs Analogues analysis to see results here.',
  },
  'analogue-tables': {
    title: 'No analogue tables',
    subtitle: 'Complete the ML analysis to populate the analogue tables.',
  },
  'krel-pc-selection': {
    title: 'No selection',
    subtitle: 'Select the Krel and Pc analogues to continue.',
  },
  'ix-tables': {
    title: 'No IX tables',
    subtitle: 'Complete the analogue selection to generate IX tables.',
  },
};
